import { AxiosInstance } from 'axios';
import { getItemInStorage } from '../../hooks/useLocalStorage';

export const addTokenOfAllRequests = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = getItemInStorage('accessToken');
      if (token && token !== '') {
        config.headers['x-access-token'] = token;
      }

      return config;
    },
    (error) => Promise.reject(error),
  );
};

export const addIFrameInfoOfAllRequests = (axiosInstance: AxiosInstance) => {
  axiosInstance.defaults.params = {};
  axiosInstance.interceptors.request.use(
    (config) => {
      config.params['is_iframe'] = true;
      return config;
    },
    (error) => Promise.reject(error),
  );
};
